import { Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { usePlan } from "@/context/PlanContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function Sospeso() {
  const { settings } = useApp();
  const { plan, refreshPlan } = usePlan();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4" data-testid="suspended-screen">
      <Card className="w-full max-w-md p-8 text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-100 text-rose-600">
          <Lock className="h-6 w-6" />
        </span>
        <h1 className="font-head mt-5 text-2xl font-bold">Servizio sospeso</h1>
        <p className="mt-2 text-sm text-slate-500">
          L'accesso al gestionale di <span className="font-semibold">{settings.business_name}</span> è momentaneamente
          sospeso. Contatta Reprehendo per riattivarlo.
        </p>
        {plan?.suspend_reason && (
          <p className="mt-3 rounded-md bg-slate-100 p-3 text-xs text-slate-600" data-testid="suspend-reason">
            {plan.suspend_reason}
          </p>
        )}
        <p className="mt-4 text-xs text-slate-500">
          I tuoi dati sono al sicuro e li ritrovi tutti alla riattivazione.
        </p>
        <Button variant="outline" className="mt-5 w-full" data-testid="retry-access-btn" onClick={refreshPlan}>
          Ho riattivato, riprova
        </Button>
      </Card>
    </div>
  );
}
